export default __webpack_public_path__ + "static/media/libraryTopBackground.8229aec2.jpg";